import React, { FC } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Header, Body } from "../styled";
import { Typography } from "@mui/material";
import { format, formatISO } from "date-fns";

const FirstEducation: FC = () => {
  return (
    <Box mt={1}>
      <Header>
        <Box display='flex'>
          <TextField
            label="Образование"
            variant="outlined"
            size="small"
            sx={{ mr: 1, width: "500px" }}
          />
          <TextField
            label="Форма обучения"
            variant="outlined"
            size="small"
            sx={{ mr: 1, mb: 1, width: "500px" }}
          />
        </Box>
        <Box display='flex'>
          <TextField
            label="Сколько классов"
            variant="outlined"
            size="small"
            sx={{ mr: 38, mb: 1, width: "204px"}}
          />
          <TextField
            label="Дата окончания"
            value={format(1683886255004, "dd.MM.yyyy")}
            variant="outlined"
            size="small"
            sx={{ width: "200px", mr: 1 }}
          />
        </Box>
        <Box display='flex'>
          <TextField
            label="Учебное заведение"
            variant="outlined"
            size="small"
            sx={{ mr: 1, width: "500px" }}
          />
          <TextField
            label="Номер диплома"
            variant="outlined"
            size="small"
            sx={{ mr: 1, mb: 1, width: "500px" }}
          />
        </Box>
        <Box display='flex'>
          <TextField
            label="Факультет"
            variant="outlined"
            size="small"
            sx={{ mr: 1, mb: 1, width: "500px" }}
          />
          <TextField
            label="Дата выдачи диплома"
            variant="outlined"
            size="small"
            sx={{ mr: 1, mb: 1, width: "500px" }}
          />
        </Box>
        <Box display='flex'>
          <TextField
            label="Специальность по диплому"
            variant="outlined"
            size="small"
            sx={{ mr: 1, width: "500px" }}
          />
          <TextField
            label="Квалификация по диплому"
            variant="outlined"
            size="small"
            sx={{ mr: 1, mb: 5, width: "500px" }}
          />
        </Box>
      </Header>
      <Body>
        <TextField
          label="Код специалности по ОКСО"
          variant="outlined"
          size="small"
          sx={{ width: "300px", mb: 1 }}
        />
        <TextField
          label="Полное наименование специальности"
          variant="outlined"
          size="small"
          sx={{ width: "800px", mb: 5 }}
        />
        <TextField
          label="Профессия основная, код по ОКПДТР"
          variant="outlined"
          size="small"
          sx={{ width: "500px", mb: 1 }}
        />
        <TextField
          label="Профессия вторая, код по ОКПДТР"
          variant="outlined"
          size="small"
          sx={{ width: "500px", mb: 2}}
        />
        <Box display="flex" alignItems="center">
          <Typography mr={1}>Научные труды: </Typography>
          <FormControlLabel
            value="female"
            control={<Radio />}
            label="имею"
          />
          <FormControlLabel
            value="female"
            control={<Radio />}
            label="не имею"
          />
        </Box>
        <Box display="flex" alignItems="center">
          <Typography mr={3} >Изобретения: </Typography>
          <FormControlLabel
            value="female"
            control={<Radio />}
            label="имею"
          />
          <FormControlLabel
            value="female"
            control={<Radio />}
            label="не имею"
            
          />
        </Box>
      </Body>
    </Box>
  );
};

export default FirstEducation;
